import React from "react";
import styled from "styled-components";

import { Modal } from "@mui/material";
import HighFivePana from "../../../../../assets/media/aden/high-five-pana.png"
import CommonButton from "../../../../../components/common/CommonButton";

const ModalFormSuccess = (props) => {
  const { modalIsOpen, handleCloseModal } = props;

  return (
    <ModalFake open={modalIsOpen} onClose={handleCloseModal}>
      <Container>
        <img src={HighFivePana} alt="high-five-pana" />
        <h1>¡Inscripción exitosa!</h1>
        <p>
            <b>El enlace al test fue enviado a tu correo electrónico. </b>
            Si no lo ves en la bandeja de entrada, revisa tu carpeta de spam, correo no deseado o promociones.
        </p>
        <CommonButton
            label="Continuar"
            variant="filled"
            onClick={handleCloseModal}
        />
      </Container>
    </ModalFake>
  );
};

export default ModalFormSuccess;

const ModalFake = styled(Modal)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    width: 450px;
    height: 70dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background-color: #fff;
    border-radius: 30px;
    padding: 2rem;

    h1 {
        font-size: 24px;
        color: #b31d15;
    }

    p {
        width: 90%;
        font-size: 16px;
        color: #222;
        text-align: center;
    }
`;